// extracted by mini-css-extract-plugin
export default {"container":"ProductCardActions-module__container-bReexB","details":"ProductCardActions-module__details-xlGHPt"};